import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerObjectClassesRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-object-classes',
	path: '/jira/assets/data-manager/object-classes',
	exact: true,
};
